import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: 'Charming Church Chums',
  date: new Date(2023, 5, 4),
  img: '/img/vampire.jpeg',
  tracks: [
    {
      title: 'Off to The Races',
      src: '/songs/2023-06-04/off_to_the_races.mp3',
    },
    {
      title: 'Expansion Pack',
      src: '/songs/2023-06-04/expansion_pack.mp3',
    },
    {
      title: 'Jubilance',
      src: '/songs/2023-06-04/jubilance.mp3',
    },
    {
      title: 'Patience',
      src: '/songs/2023-06-04/patience.mp3',
    },
    {
      title: 'Incandescence',
      src: '/songs/2023-06-04/incandescence.mp3',
    },
    {
      title: 'Boots Traps',
      src: '/songs/2023-06-04/boots_traps.mp3',
    },
    {
      title: 'Iridescence',
      src: '/songs/2023-06-04/iridescence.mp3',
    },
    {
      title: 'Ten Minutes to Live',
      src: '/songs/2023-06-04/ten_minutes_to_live.mp3',
    },
    {
      title: 'Come & Play',
      src: '/songs/2023-06-04/come_and_play.mp3',
    },
    {
      title: 'Destiny Calling',
      src: '/songs/2023-06-04/destiny_calling.mp3',
    },
    {
      title: 'Vampire',
      src: '/songs/2023-06-04/vampire.mp3',
    },
    {
      title: 'Comin\' in Hot',
      src: '/songs/2023-06-04/comin_in_hot.mp3',
    },
    {
      title: 'Ephemeral Voices',
      src: '/songs/2023-06-04/ephemeral_voices.mp3',
    },
    {
      title: 'Mindfulness',
      src: '/songs/2023-06-04/mindfulness.mp3',
    },
    {
      title: '3am Traffic',
      src: '/songs/2023-06-04/3am_traffic.mp3',
    },
  ]
}
export default album;